import { render, staticRenderFns } from "./NewsBell.vue?vue&type=template&id=619ca18e&scoped=true"
import script from "./NewsBell.vue?vue&type=script&lang=js"
export * from "./NewsBell.vue?vue&type=script&lang=js"
import style0 from "./NewsBell.vue?vue&type=style&index=0&id=619ca18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619ca18e",
  null
  
)

export default component.exports